import * as React from "react";
import { Classes, Icon, IconNames, Position, Tooltip } from "@focus/focusUI";
import LegendList from "./LegendList";
import LegendFilter from "./LegendFilter";
import "./Legend.scss";
import { useVisibleValues, } from "../Containers/VisibleValuesContext";
const Legend = ({ hidden, height, margins, legendProperties, objectProperties, minimal, toggleHidden, showLabel, }) => {
    const { removeAllLegendRows, showAllLines, toggleVariable, visibleValues, setVisibleValues, } = useVisibleValues();
    const allLines = generateLines(legendProperties);
    const [filterString, setFilterString] = React.useState("");
    React.useEffect(() => {
        if (!visibleValues) {
            setVisibleValues(allLines);
        }
    }, [legendProperties]);
    const cleanFiltering = () => {
        showAllLines();
        setFilterString("");
    };
    const handleFilterChange = (e) => {
        const newFilteredLines = filterLines(e.target.value, allLines);
        setVisibleValues(newFilteredLines);
        setFilterString(e.target.value);
    };
    const filterLines = (filter, lines) => {
        const newFilterString = filter.toLowerCase();
        const newFilteredLines = Object.keys(lines).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: legendProperties[key].title
                .toLowerCase()
                .includes(newFilterString) })), {});
        return newFilteredLines;
    };
    let divClass = "legend-container";
    divClass += hidden ? " legend-container-unuse" : " legend-container-use";
    return (React.createElement("div", { style: {
            zIndex: 1,
            height: "100%",
            pointerEvents: hidden ? "none" : undefined,
        } },
        React.createElement("div", { className: divClass, style: { top: margins.top + "px" } },
            React.createElement("div", { className: "legend-container-left" },
                !hidden && visibleValues && (React.createElement(LegendFilter, { inputOnChange: handleFilterChange, onFilterClean: cleanFiltering, placeholder: "Filter data...", value: filterString, removeAllLegendRows: removeAllLegendRows })),
                !hidden && visibleValues && (React.createElement(LegendList, { legendValues: visibleValues, minimal: minimal, legendProperties: legendProperties, objectProperties: objectProperties, toggleVariable: toggleVariable, height: height !== null ? height - margins.top - 35 : null, showLabel: showLabel }))),
            React.createElement(Tooltip, { className: "legend-tooltip", usePortal: false, position: Position.LEFT, hoverOpenDelay: 400, content: hidden ? "Show legend" : "Hide legend" },
                React.createElement("div", { className: `legend-toggler ${Classes.BUTTON}`, onClick: toggleHidden },
                    React.createElement(Icon, { icon: hidden ? IconNames.CARET_LEFT : IconNames.CARET_RIGHT }))))));
};
export default Legend;
const generateLines = (legendProperties) => {
    return Object.keys(legendProperties).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: true })), {});
};
//# sourceMappingURL=index.js.map